var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackOrderNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.455 1.27344H3.86408C3.13607 1.27344 2.5459 1.87678 2.5459 2.62103V11.3804C2.5459 12.1246 3.13607 12.728 3.86408 12.728H10.455C11.183 12.728 11.7732 12.1246 11.7732 11.3804V2.62103C11.7732 1.87678 11.183 1.27344 10.455 1.27344Z",
    stroke: "#444444",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18262 4.64062H9.13716M5.18262 7.33581H9.13716M5.18262 10.031H7.81898",
    stroke: "#444444",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackOrderNoteIcon);
export default __webpack_public_path__ + "static/media/Black_OrderNote_Icon.c0fcf0a0b8bb7669ca2fe52d9e2c144b.svg";
export { ForwardRef as ReactComponent };